export const TwentySix = 'w';